/* eslint-disable import/no-named-as-default */
import React, { Component, Fragment, ReactNode } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Timeline from "../../Charts/Timeline";
import AnalyticsWidgetLoading from "../../shared/loaders/AnalyticsWidgetLoading";
import { Wrapper } from "../styles/charts-styles";
import { ChartTitle } from "../styles/employer-analytics-styles";
import ReactTooltip from "react-tooltip";

export interface ITimeToHireProps {
  timeToHire: {
    months?: Date[];
    values?: number[];
  };
  timeToHireWidgetLoader: boolean;
}

export class TimeToHire extends Component<ITimeToHireProps> {
  static propTypes = {
    timeToHire: PropTypes.shape({
      months: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
      values: PropTypes.arrayOf(PropTypes.number),
    }),
    timeToHireWidgetLoader: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    timeToHire: {
      months: [],
      values: [],
    },
  };

  render(): ReactNode {
    const { timeToHire, timeToHireWidgetLoader } = this.props;

    const timeToHireOptions = {
      series: [
        {
          name: "Time to hire",
          data: timeToHire.values,
        },
      ],
      options: {
        height: 350,
        colors: ["#402680"],

        chart: {
          type: "line",
          offsetY: -5,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: [1],
          curve: "straight",
        },
        markers: {
          size: 5,
          radius: 5,
          shape: "circle",
        },

        tooltip: {
          x: {
            formatter: function (value) {
              const date = new Date(value);
              return date.toLocaleString("default", { month: "short" });
            },
          },

          y: [
            {
              title: {
                formatter: (val: string) => val,
              },
            },
          ],
        },
        xaxis: {
          type: "datetime",
          categories: timeToHire.months.map((date) => date.getTime()),
          title: {
            text: "Time",
          },
        },
        yaxis: {
          title: {
            text: "Number of Days",
          },
        },
        legend: {
          offsetY: 5,
          tooltipHoverFormatter: (
            val: string,
            opts: {
              // I've typed the opts manually because ApexCharts seem to have
              // typed this as 'any' which our lint config doesn't like
              // (at the time of writing, anyway) see
              // https://github.com/apexcharts/apexcharts.js/blob/master/types/apexcharts.d.ts#L744
              w: {
                globals: { series: number[][] };
              };
              seriesIndex: number;
              dataPointIndex: number;
            }
          ) => {
            const value = `${val} - ${
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex]
            } `;
            return value;
          },
        },
      },
    };
    // console.log(spendPerSectorOptions);

    return (
      <Fragment>
        <Wrapper className="animated fadeIn delay-5" id="time-to-hire-widget">
          <AnalyticsWidgetLoading
            text="Updating..."
            active={timeToHireWidgetLoader}
          />

          <Timeline
            graphOptions={timeToHireOptions}
            dataTestId="time-to-hire-chart"
          />
          <ChartTitle
            marginBottom={20}
            data-test-id="time-to-hire-title"
            data-tip="Average time taken to fill a role."
            data-for="time-to-hire-title-tooltip"
          >
            <ReactTooltip
              type="dark"
              aria-haspopup="true"
              id="time-to-hire-title-tooltip"
              className="tooltip-max-width"
            />
            Time to Hire (Days)
          </ChartTitle>
        </Wrapper>
      </Fragment>
    );
  }
}

interface IReduxState {
  employerAnalytics: {
    currencySymbol?: string;
    jobPerformanceData: {
      timeToHire: {
        months: Date[];
        values: number[];
      };
    };
    timeToHireWidgetLoader: boolean;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  timeToHire: state.employerAnalytics.jobPerformanceData.timeToHire,
  timeToHireWidgetLoader: state.employerAnalytics.timeToHireWidgetLoader,
});

export default connect(mapStateToProps, {})(TimeToHire);
